export default __webpack_public_path__ + "static/media/Bottom_upload_selected.4c2d4772.svg";